<template>
  <basic-container>
    <h3 style="margin: 10px 0px 10px 10px;" v-text="$route.query.name"></h3>
    <el-button class="btn" v-for="(item,i) in list" :key="i" @click="btnClick(item)">{{item.SERVER_NAME}}</el-button>
  </basic-container>
</template>

<script>
import {getShow} from "@/api/table/table";
import {getUserPassword} from "@/api/system/user";
import {parseParams} from '@/util/util';
import {mapGetters} from "vuex";
export default {
  computed:{
    ...mapGetters(['userInfo']),
  },
  data() {
    return {
      list:[],
    };
  },
  mounted() {},
  methods: {
    // 按钮点击
    btnClick(item){
      getUserPassword(this.$qs.stringify({temps:new Date().getTime(),runId:this.$route.query.runId})).then(res=>{
        console.log(res.data.data);
        let url = parseParams(item.SERVER_URL+'/#'+this.$route.query.path+'?',{runId:-1,type:"1",path:this.$route.query.path,user:this.userInfo.user_acc,p:res.data.data,loginType:1,c_id:item.COMPANY_ID,TYGXJGFW:1,zong:item.COMPANY_ID}); // p 是密码,c_id是当前点击的总队ID
        window.console.log(url);
        window.open(url, '_blank');
      })
    }
  },
  created(){
    let SERVER_TYPE = "";
    if(this.userInfo.isinnernet){
      SERVER_TYPE = 1
    }else{
      SERVER_TYPE = 2
    }
    getShow(1, 99,this.$route.query.runId, {
      opid: 3540,
      obj:{SERVER_TYPE:SERVER_TYPE,STATUS:"1"}
    }).then(res=>{
      this.list=res.data.data.records;
      console.log(this.list);
    })
  }
};
</script>

<style lang="scss" scoped>
.btn{
  width: 230px;
  margin: 10px;
}
/deep/.el-button{
  padding: 12px 6px !important;
}
</style>
